<script>
  import { format } from 'svelte-i18n';
  import { ListGroupItem } from '@sveltestrap/sveltestrap';
  import { format as formatDate } from 'date-fns';

  import { SYNC_HISTORY_TYPES } from '@client/enums';

  export let event = {};
</script>

<ListGroupItem class="d-flex align-items-center px-0 py-2">
  <div class="me-5">
    {formatDate(new Date(event.timestamp), 'MM/dd/yy')}<br />
    <small class="text-secondary">{formatDate(new Date(event.timestamp), 'h:mma')}</small>
  </div>
  <div class="me-3 h6">
    {$format(SYNC_HISTORY_TYPES[event.action]?.label)}<br />
    <small class="text-secondary">
      {$format(`label.SYNC_HISTORY_COUNT_${SYNC_HISTORY_TYPES[event.action]?.type}`, {
        values: { count: event.note.count, type: event.type, user: event.user }
      })}
    </small>
  </div>
</ListGroupItem>
